import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  MenuItem,
  Typography,
  CircularProgress,
  alpha,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import {
  showToast,
  WEBSERVICE,
  TRADESERVICE,
  handleGetAssetCode,
  handleGetAssetId,
  checkCurrencyPairAccreditedStatus,
} from "../../CoreDataService";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FeeModal from "../Convert/FeeModal";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import { ContainedButton } from "../../Common/Buttons";
import AccreditationVerificationPopup from "../Accredited-Kyc/AccreditationVerificationPopup";
import TermsAgreementPopup from '../Accredited-Kyc/TermsAgreementPopup';
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function Otc() {
  const navigate = useNavigate();
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);

  const [tabIndex, setTabIndex] = useState(0);
  const [amount, setAmount] = useState("0");
  const [balanceList, setBalanceList] = useState([]);
  const [currencyBalance, setCurrencyBalance] = useState([]);
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState(null);
  const [buyingCryptoBalance, setBuyingCryptoBalance] = useState("");
  const [sellingCryptoBalance, setSellingCryptoBalance] = useState("");
  const [errorMessage, showErrorMessage] = useState(null);
  const [counterCurrency, setCounterCurrency] = useState([]);

  const [isBuySellEligible, setIsBuySellEligible] = useState(true);
  const [onlyBuyPrice, setOnlyBuyPrice] = useState(null);
  const [onlyBuyPrice1, setOnlyBuyPrice1] = useState(null);

  const [onlySellPrice, setOnlySellPrice] = useState(null);
  const [onlyBuyAmount, setOnlyBuyAmount] = useState(0);
  const [onlySellAmount, setOnlySellAmount] = useState(0);
  const [onlyBuyTotalPrice, setOnlyBuyTotalPrice] = useState(null);
  const [onlySellTotalPrice, setOnlySellTotalPrice] = useState(null);
  const [marketPrice, setMarketPrice] = useState(null);
  const [baseCurrencyList, setBaseCurrencyList] = useState([]);
  const [selectedBuyingAssetBalance, setSelectedBuyingAssetBalance] =
    useState(null);
  const [countdown, setCountdown] = useState(3);
  const [selectedBaseCurrency, setSelectedBaseCurrency] = useState([]);
  const [selectedCounterCurrency, setSelectedCounterCurrency] = useState([]);
  const [showQuoteAreaForBuy, setShowQuoteAreaForBuy] = useState(false);
  const [showRefreshButtonForBuy, setShowRefreshButtonForBuy] = useState(false);
  const [intervalForBuy, setIntervalForBuy] = useState(null);
  const [isAmountDisabled, setIsAmountDisabled] = useState(true);
  const [isBaseDisabled, setIsBaseDisabled] = useState(true);
  const [isGetQuoteDisabled, setIsGetQuoteDisabled] = useState(true);
  const [isBalanceShow, setIsBalanceShow] = useState(false);
  const [intervalForSell, setIntervalForSell] = useState(null);
  const [showRefreshButtonForSell, setShowRefreshButtonForSell] =
    useState(false);
  const [showQuoteAreaForSell, setShowQuoteAreaForSell] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [errorDepthPriceExceed, setErrorDepthPriceExceed] = useState(false);
  const [errorTotalPriceExceed, setErrorTotalPriceExceed] = useState(false);
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [termsLinks, setTermsLinks] = useState([]);
  const [pendingProceed, setPendingProceed] = useState(null);
  const [pendingTxnType, setPendingTxnType] = useState(null);

  const intervalForBuyRef = useRef(null);
  const intervalForSellRef = useRef(null);
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === "dark";

  const handleCancelRequestForSell = () => {
    setShowQuoteAreaForSell(false);
    clearInterval(intervalForSell);
    setCountdown(3);
  };

  const resetAll = () => {
    setShowQuoteAreaForBuy(false);
    setShowQuoteAreaForSell(false);
    setIsAmountDisabled(true);
    setIsBaseDisabled(true);
    setIsGetQuoteDisabled(true);
    clearInterval(intervalForSell);
    clearInterval(intervalForBuy);
    setSelectedCounterCurrency("");
    setSelectedBaseCurrency("");

    setOnlyBuyAmount(0);
    setOnlySellAmount("");
    setIsBalanceShow(false);
  };

  useEffect(() => {
    console.log("Reset state updated", {
      showQuoteAreaForSell,
      isAmountDisabled,
      selectedCounterCurrency,
      selectedBaseCurrency,
      onlyBuyAmount,
      onlySellAmount,
    });
  }, [
    showQuoteAreaForSell,
    isAmountDisabled,
    selectedCounterCurrency,
    selectedBaseCurrency,
    onlyBuyAmount,
    onlySellAmount,
  ]);

  useEffect(() => {
    getBasecurrencyList();
    getUserTransaction("load");
    getAllAssetPairCurrencyPrecisionList();
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      clearInterval(intervalForBuy);
      setShowRefreshButtonForBuy(true);
    }
  }, [countdown]);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleCancelRequestForBuy = () => {
    setShowQuoteAreaForBuy(false);
    clearInterval(intervalForBuy);
    setCountdown(3);
  };

  const marketBuy = async () => {
    setIsLoading(true);
    setErrorDepthPriceExceed(false);
    setErrorTotalPriceExceed(false);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(localStorage.getItem("userId"), selectedCounterCurrency, selectedBaseCurrency, 'BUY', onlyBuyAmount);

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doMarketBuy();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(1);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doMarketBuy = async () => {
    setIsLoading(true);
    setErrorDepthPriceExceed(false);
    setErrorTotalPriceExceed(false);

    if (isBuySellEligible) {
      try {
        const response = await axios.get(
          `${TRADESERVICE}?symbol=${selectedCounterCurrency}${selectedBaseCurrency}&side=BID&amount=${onlyBuyAmount}`
        );
        if (response.data.statuscode != 0) {
          setOnlyBuyPrice(response.data.price);
          setOnlyBuyTotalPrice(response.data.price * amount);
          var setOnlyBuyPrice2 = response.data.price1;
          setOnlyBuyPrice1(response.data.price1);

          const offerPayload = {
            selling_asset_code: selectedBaseCurrency.toUpperCase(),
            buying_asset_code: selectedCounterCurrency.toUpperCase(),
            userId: localStorage.getItem("user_id"),
            price: setOnlyBuyPrice2,
            txn_type: "1",
          };

          const offerResponse = await axios.post(
            `${WEBSERVICE}userTrade/OfferPriceCheck`,
            offerPayload
          );

          if (offerResponse.data.error.error_data != 0) {
            showToast("warning", offerResponse.data.error.error_msg);
          } else {
            var assetCode = handleGetAssetCode(
              selectedCounterCurrency.toUpperCase(),
              selectedBaseCurrency.toUpperCase()
            );
            var baseCurrencyId = handleGetAssetId(
              selectedCounterCurrency.toUpperCase(),
              selectedBaseCurrency.toUpperCase()
            )["baseCurrencyId"];
            var currencyId = handleGetAssetId(
              selectedCounterCurrency.toUpperCase(),
              selectedBaseCurrency.toUpperCase()
            )["currencyId"];

            console.log("baseCurrencyId", baseCurrencyId);

            const tradePayload = {
              ...offerPayload,
              amount: parseFloat(onlyBuyAmount),
              offerType: "M",
              assetCode: assetCode.toUpperCase(),
              baseCurrencyId: baseCurrencyId,
              currencyId: currencyId,
              uuid: localStorage.getItem("uuid"),
            };

            if (setOnlyBuyPrice2 * onlyBuyAmount >= 0.001) {
              const tradeResponse = await axios.post(
                `${WEBSERVICE}userTrade/TradeCreateOffer`,
                tradePayload,
                {
                  headers: {
                    "Content-Type": "application/json",
                    authorization: `BEARER ${localStorage.getItem(
                      "access_token"
                    )}`,
                  },
                }
              );
              if (tradeResponse.data.error.error_data != 0) {
                showToast("error", tradeResponse.data.error.error_msg);
                handleCancelRequestForBuy();
                setIsGetQuoteDisabled(true);
                setOnlyBuyAmount(0);
              } else {
                showToast("success", tradeResponse.data.error.error_msg);
                renderUpdatedBalance("buy", selectedBaseCurrency);
              }
            } else {
              console.log(
                "permiss",
                setOnlyBuyPrice2,
                "----",
                onlyBuyAmount,
                "----",
                setOnlyBuyPrice2 * onlyBuyAmount
              );

              showToast(
                "warning",
                "Offer Value is lesser than permissible value"
              );
              handleCancelRequestForBuy();
              setIsGetQuoteDisabled(true);
              renderUpdatedBalance("buy", selectedBaseCurrency);
            }
          }
        } else {
          setErrorDepthPriceExceed(true);
          showToast("error", "Market buy failed");
        }
      } catch (error) {
        console.log(error);
        showToast("error", "An error occurred");
      }
    } else {
      handleBuySellCurrencyConversion(onlyBuyAmount, 1);
    }

    setIsLoading(false);
  };

  const handleBuySellCurrencyConversion = async (amount, flag) => {
    const userId = localStorage.getItem("user_id");
    const token = localStorage.getItem("access_token");

    const inputObj = {
      userId,
      baseCurrency: selectedBaseCurrency.toUpperCase(),
      currency: selectedCounterCurrency.toUpperCase(),
      amount: parseFloat(amount),
      action: flag,
    };

    try {
      setIsLoading(true);
      setIsGetQuoteDisabled(false);

      const response = await axios.post(
        `${WEBSERVICE}home/currencyConversion`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      setIsLoading(false);

      const result = response.data;
      if (result.error?.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        resetAll();
        showToast("success", result.error.error_msg);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        showToast("error", "Something went wrong!");
      }
    }
  };

  const marketSell = async () => {
    const accreditationResult = await checkCurrencyPairAccreditedStatus(localStorage.getItem("userId"), selectedCounterCurrency, selectedBaseCurrency, 'SELL', onlySellAmount);

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doMarketSell();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(2);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doMarketSell = async () => {
    if (isBuySellEligible) {
      try {
        setIsLoading(true);
        setIsGetQuoteDisabled(true);

        const response = await axios.get(
          `${TRADESERVICE}?symbol=${selectedCounterCurrency}${selectedBaseCurrency}&side=ASK&amount=${onlySellAmount}`
        );
        if (response.data.statuscode != 0) {
          setOnlySellPrice(response.data.price);
          setOnlySellTotalPrice(response.data.price * onlySellAmount);
          var setOnlySellPrice2 = response.data.price1;

          const offerPayload = {
            selling_asset_code: selectedCounterCurrency.toUpperCase(),
            buying_asset_code: selectedBaseCurrency.toUpperCase(),
            userId: localStorage.getItem("user_id"),
            price: setOnlySellPrice2,
            txn_type: "2",
          };

          const offerResponse = await axios.post(
            `${WEBSERVICE}userTrade/OfferPriceCheck`,
            offerPayload
          );
          if (offerResponse.data.error.error_data != 0) {
            showToast("warning", offerResponse.data.error.error_msg);
          } else {
            var assetCode = handleGetAssetCode(
              selectedCounterCurrency.toUpperCase(),
              selectedBaseCurrency.toUpperCase()
            );
            var baseCurrencyId = handleGetAssetId(
              selectedCounterCurrency.toUpperCase(),
              selectedBaseCurrency.toUpperCase()
            )["baseCurrencyId"];
            var currencyId = handleGetAssetId(
              selectedCounterCurrency.toUpperCase(),
              selectedBaseCurrency.toUpperCase()
            )["currencyId"];

            const tradePayload = {
              ...offerPayload,
              amount: parseFloat(onlySellAmount),
              offerType: "M",
              assetCode: assetCode.toUpperCase(),
              baseCurrencyId: baseCurrencyId,
              currencyId: currencyId,
              uuid: localStorage.getItem("uuid"),
            };

            if (setOnlySellPrice2 * onlySellAmount >= 0.001) {
              const tradeResponse = await axios.post(
                `${WEBSERVICE}userTrade/TradeCreateOffer`,
                tradePayload,
                {
                  headers: {
                    "Content-Type": "application/json",
                    authorization: `BEARER ${localStorage.getItem(
                      "access_token"
                    )}`,
                  },
                }
              );
              if (tradeResponse.data.error.error_data != 0) {
                showToast("error", tradeResponse.data.error.error_msg);
                handleCancelRequestForSell();
                setIsGetQuoteDisabled(true);
                setOnlySellAmount(0);
              } else {
                showToast("success", tradeResponse.data.error.error_msg);
                renderUpdatedBalance("sell", selectedCounterCurrency);
              }
            } else {
              showToast(
                "warning",
                "Offer Value is lesser than permissible value"
              );
              handleCancelRequestForSell();
              setIsGetQuoteDisabled(true);
            }
          }
          setIsLoading(false);
        } else {
          setIsLoading(false);
          showToast("error", "Market sell failed");
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
        showToast("error", "An error occurred");
      }
    } else {
      handleBuySellCurrencyConversion(onlySellAmount, 2);
    }
  };

  const handleGetQuoteForBuy = () => {
    clearInterval(intervalForBuy);
    setCountdown(3);
    if (onlyBuyAmount != "" && onlyBuyAmount != 0) {
      setShowQuoteAreaForBuy(true);
      setShowRefreshButtonForBuy(false);
      const newInterval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown <= 1) {
            clearInterval(newInterval);
            setShowRefreshButtonForBuy(true);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
      setIntervalForBuy(newInterval);
    } else {
      showToast("warning", "Please provide a valid amount");
    }
  };

  const handleGetQuoteForSell = () => {
    if (intervalForSellRef.current) clearInterval(intervalForSellRef.current);
    setCountdown(3);

    if (onlySellAmount !== "" && onlySellAmount !== 0) {
      setShowQuoteAreaForSell(true);
      setShowRefreshButtonForSell(false);

      intervalForSellRef.current = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown <= 1) {
            clearInterval(intervalForSellRef.current);
            setShowRefreshButtonForSell(true);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    } else {
      showToast("warning", "Please provide a valid amount");
    }
  };

  const getBasecurrencyList = async () => {
    const brokerId = localStorage.getItem("BROKERID");
    const accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getAllCurrency/${brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const result = response.data;
      setCounterCurrency(result.currencyList);
    } catch (error) {
      if (error.response) {
        showToast("error", `${error.response.status}`);
        console.error(
          "Error fetching base currency list:",
          error.response.data
        );
      } else {
        showToast("error", "An unexpected error occurred");
        console.error("Unexpected error:", error);
      }
    }
  };

  const getAllAssetPairCurrencyPrecisionList = async () => {
    try {
      const response = await axios.get(
        WEBSERVICE + "/home/assetpairPrecision",
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data != 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        localStorage.setItem(
          "asset_pair_precision_list",
          JSON.stringify(response.data.assetPairList)
        );
      }
    } catch (error) {
      console.error("Error fetching asset pair precision list", error);
    }
  };

  const getUserTransaction = async (type) => {
    const userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      setBalanceList(result.userBalanceList);
      setCurrencyBalance(result.userBalanceList);

      if (result.userBalanceList) {
        result.userBalanceList.forEach((balance) => {
          if (balance.currencyCode === "USD") {
            localStorage.setItem("usdbalance", balance.closingBalance);
          }
        });
      }

      if (result.error.error_data != "0") {
        showToast("error", "Cannot fetch user balance");
      } else {
        setSelectedCryptoCurrency(localStorage.getItem("selected_currency"));

        if (type === "buy") {
          getBaseCurrency(selectedBaseCurrency);
        } else if (type === "sell") {
          getCounterCurrency(selectedCounterCurrency);
        }
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401 || error.response.status === 400) {
          localStorage.clear();
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        } else if (![200, 429, 403].includes(error.response.status)) {
          showToast("error", error.message);
        }
      }
    }
  };

  const renderUpdatedBalance = (action, latestCurrency) => {
    console.log("latestCurrency", latestCurrency);

    const userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    const jsonString = JSON.stringify(userTransObj);

    axios
      .post(`${WEBSERVICE}transaction/getUserBalance`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        const result = response.data;

        if (result.error.error_data !== 0) {
          showToast("error", "Cannot fetch user balance");
        } else {
          const balance = result.userBalanceList;
          for (let i = 0; i < balance.length; i++) {
            if (action === "buy") {
              if (balance[i].currencyCode === latestCurrency.toUpperCase()) {
                setBuyingCryptoBalance(balance[i].closingBalance);
                break;
              }
            } else {
              if (balance[i].currencyCode === latestCurrency.toUpperCase()) {
                setSellingCryptoBalance(balance[i].closingBalance);
                break;
              }
            }
          }
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const getBaseCurrency = (baseCurrency) => {
    setIsAmountDisabled(false);
    setSelectedBaseCurrency(baseCurrency);

    const filteredBalance = balanceList.find(
      (x) => x.currencyCode === baseCurrency
    );
    console.log("baseCurrency", baseCurrency);

    if (tabIndex === 0) {
      if (filteredBalance) {
        setBuyingCryptoBalance(filteredBalance.closingBalance);
        console.log("closingBalance buy", filteredBalance.closingBalance);
      }
      getPairWiseBuySellCheck(selectedCounterCurrency, baseCurrency, 1);
      setIsBalanceShow(true);
    } else {
      getPairWiseBuySellCheck(selectedCounterCurrency, baseCurrency, 2);
      setIsBalanceShow(true);
    }
  };

  const getPairWiseBuySellCheck = async (currency, baseCurrency, action) => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/pairWiseBuySellChecking?currency=${currency}&baseCurrency=${baseCurrency}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        if (response.data.buySellFlag === 0) {
          setIsBuySellEligible(false);
          fetchMarketPrice(currency, baseCurrency, action);
        } else {
          setIsBuySellEligible(true);
        }
      }
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const fetchMarketPrice = async (currency, baseCurrency, action) => {
    try {
      const payload = { currency, baseCurrency, action };
      const response = await axios.post(
        `${WEBSERVICE}home/marketPrice`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        if (action === 1) {
          setOnlyBuyPrice(response.data.marketPrice);
          setMarketPrice(response.data.marketPrice);
          setOnlyBuyTotalPrice(parseFloat(response.data.marketPrice) * 1);
        } else {
          setOnlySellPrice(response.data.marketPrice);
          setMarketPrice(response.data.marketPrice);
          setOnlySellTotalPrice(parseFloat(response.data.marketPrice) * 1);
        }
      }
    } catch (error) {
      if (error.response?.status === 401) {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
      }
    }
  };

  const getCounterCurrency = async (currency) => {
    try {
      setIsBaseDisabled(false);
      setSelectedCounterCurrency(currency);
      setOnlySellAmount("");
      setOnlyBuyAmount("");

      const response = await axios.get(
        `${WEBSERVICE}home/getBaseByCurrency?brokerId=${localStorage.getItem(
          "BROKERID"
        )}&currency=${currency}&country=${localStorage.getItem("userCountry")}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      setBaseCurrencyList(result.baseCurrencyList);
      renderUpdatedBalance("sell", currency);
    } catch (error) {
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.clear();
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      } else if (![200, 429, 403].includes(error.response.status)) {
        showToast("warning", error.message);
      }
    }
  };

  const getBuyVal = async (val) => {
    clearInterval(intervalForBuy);
    setCountdown(2);

    setErrorTotalPriceExceed(false);
    setErrorDepthPriceExceed(false);

    if (val < 0 || val === "") {
      showToast("warning", "Amount cannot be negative or blank");
      setOnlyBuyAmount("");
      return;
    }

    setOnlyBuyAmount(val);
    setShowRefreshButtonForBuy(false);
    setIsGetQuoteDisabled(false);

    const symbol = selectedCounterCurrency + selectedBaseCurrency;
    const pricePrecision =
      getSpecificAssetPairPrecision(symbol)?.pricePrecision || 4;

    if (isBuySellEligible) {
      try {
        const response = await axios.get(
          `${TRADESERVICE}?symbol=${symbol}&side=BID&amount=${val}`
        );

        if (response.data.statuscode !== "0") {
          const price = parseFloat(response.data.price);
          const total = price * parseFloat(val);

          setOnlyBuyPrice(price.toFixed(pricePrecision));
          setOnlyBuyTotalPrice(total.toFixed(pricePrecision));

          var tempBuyTotalPrice = (
            parseFloat(response.data.price) * parseFloat(val)
          ).toFixed(pricePrecision);
          setOnlyBuyTotalPrice(tempBuyTotalPrice);
          if (tempBuyTotalPrice < 0.001) {
            setErrorTotalPriceExceed(true);
          } else {
            setErrorTotalPriceExceed(false);
          }

          if (total < 0.001) {
            setErrorTotalPriceExceed(true);
          } else {
            setErrorTotalPriceExceed(false);
          }

          setErrorDepthPriceExceed(false);
        } else {
          setOnlyBuyPrice(0);
          setOnlyBuyTotalPrice(0);
          setErrorDepthPriceExceed(true);
        }

        const newInterval = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(newInterval);
              setShowRefreshButtonForBuy(true);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
        setIntervalForBuy(newInterval);
      } catch (error) {
        if (error.response?.status === 401) {
          showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      }
    } else {
      const price = parseFloat(marketPrice);
      const total = price * parseFloat(val);

      setOnlyBuyPrice(price.toFixed(pricePrecision));
      setOnlyBuyTotalPrice(total.toFixed(pricePrecision));

      if (total < 0.001) {
        setErrorTotalPriceExceed(true);
      } else {
        setErrorTotalPriceExceed(false);
      }

      setErrorDepthPriceExceed(false);

      const newInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(newInterval);
            setShowRefreshButtonForBuy(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      setIntervalForBuy(newInterval);
    }
  };

  const getSpecificAssetPairPrecision = (symbol) => {
    const list =
      JSON.parse(localStorage.getItem("asset_pair_precision_list")) || [];
    const matched = list.find(
      (item) => item.assetPair.toUpperCase() === symbol.toUpperCase()
    );
    return matched || { amountPrecision: 2, pricePrecision: 4 };
  };

  const getSellVal = async (val) => {
    clearInterval(intervalForSell);
    setCountdown(3);
    setErrorTotalPriceExceed(false);
    setErrorDepthPriceExceed(false);

    const symbol = selectedCounterCurrency + selectedBaseCurrency;
    const pricePrecision =
      getSpecificAssetPairPrecision(symbol)?.pricePrecision || 4;

    setShowRefreshButtonForSell(false);
    setOnlySellAmount(val);
    setIsGetQuoteDisabled(false);

    if (val < 0 || val === "") {
      showToast("error", "Amount cannot be negative or blank");
      setOnlySellAmount("");
      return;
    }

    if (isBuySellEligible) {
      try {
        const response = await axios.get(
          `${TRADESERVICE}?symbol=${selectedCounterCurrency}${selectedBaseCurrency}&side=ASK&amount=${val}`
        );
        if (response.data.statuscode !== "0") {
          setOnlySellPrice(parseFloat(response.data.price).toFixed(4));
          var tempOnlySellTotalPrice = (
            parseFloat(response.data.price) * parseFloat(val)
          ).toFixed(4);

          setOnlySellTotalPrice(tempOnlySellTotalPrice);

          if (tempOnlySellTotalPrice < 0.001) {
            setErrorTotalPriceExceed(true);
          } else {
            setErrorTotalPriceExceed(false);
          }
        } else {
          setOnlySellPrice(0);
          setOnlySellTotalPrice(0);
          setErrorDepthPriceExceed(true);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        }
      }
    } else {
      console.log("here");

      const price = parseFloat(marketPrice);
      const total = price * parseFloat(val);

      console.log("price", price);

      setOnlySellPrice(price.toFixed(pricePrecision));
      setOnlySellTotalPrice(total.toFixed(pricePrecision));

      if (total < 0.001) {
        setErrorTotalPriceExceed(true);
      } else {
        setErrorTotalPriceExceed(false);
      }

      setErrorDepthPriceExceed(false);
    }

    const newInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          clearInterval(newInterval);
          setShowRefreshButtonForSell(true);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);
    setIntervalForSell(newInterval);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const isBuy = tabIndex === 0;

  return (
    <Box sx={pageWrapper}>

      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.72)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <CompareArrowsOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>
              {brokerBasicInfo?.exchange || ""} OTC Trading Portal
            </Typography>
            <Typography sx={heroSubtitle}>
              Request for Quote — Execute large trades at institutional prices
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Main Card ── */}
      <Box sx={mainCard}>

        {/* Tabs + Fees button */}
        <Box sx={tabsWrap}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            sx={{
              ...tabsStyle,
              "& .MuiTabs-indicator": {
                backgroundColor: isBuy ? "#16a34a" : "#ef4444",
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
            }}
          >
            <Tab
              iconPosition="start"
              icon={<TrendingUpOutlinedIcon sx={{ fontSize: 18 }} />}
              label="I want to Buy"
              onClick={resetAll}
              sx={{
                ...tabItem,
                "&.Mui-selected": { color: "#16a34a", opacity: 1 },
              }}
            />
            <Tab
              iconPosition="start"
              icon={<TrendingDownOutlinedIcon sx={{ fontSize: 18 }} />}
              label="I want to Sell"
              onClick={resetAll}
              sx={{
                ...tabItem,
                "&.Mui-selected": { color: "#ef4444", opacity: 1 },
              }}
            />
          </Tabs>

          <Box sx={{ display: "flex", alignItems: "center", pr: 2 }}>
            <ContainedButton
              variant="contained"
              size="small"
              onClick={openModal}
              sx={{
                height: 32,
                px: 2,
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.78rem",
              }}
            >
              View Fees
            </ContainedButton>
            <FeeModal open={modalOpen} onClose={closeModal} />
          </Box>
        </Box>

        {/* ── Form Panel ── */}
        <Box sx={tabPanel}>

          {/* Balance strip */}
          {isBalanceShow && (
            <Box sx={balanceStrip}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <AccountBalanceWalletOutlinedIcon
                  sx={{ fontSize: 14, opacity: 0.5, color: "var(--text-color)" }}
                />
                <Typography sx={balanceLabel}>Available Balance</Typography>
              </Box>
              <Typography sx={balanceValue}>
                {isBuy ? buyingCryptoBalance : sellingCryptoBalance}{" "}
                <span style={{ opacity: 0.55, fontWeight: 400, fontSize: "0.75rem" }}>
                  {isBuy ? selectedBaseCurrency : selectedCounterCurrency}
                </span>
              </Typography>
            </Box>
          )}

          {/* Currency pair + amount fields */}
          <Box sx={fieldsGrid}>
            {/* Counter currency */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>
                {isBuy ? "Buy Currency" : "Sell Currency"}
              </Typography>
              <TextField
                select
                value={selectedCounterCurrency}
                onChange={(e) => getCounterCurrency(e.target.value)}
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="">Select Currency</MenuItem>
                {counterCurrency.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Base currency */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>
                {isBuy ? "Spend" : "Receive"}
              </Typography>
              <TextField
                select
                value={selectedBaseCurrency}
                disabled={isBaseDisabled}
                onChange={(e) => getBaseCurrency(e.target.value)}
                sx={modernFieldStyle}
                fullWidth
              >
                <MenuItem value="">Select Currency</MenuItem>
                {baseCurrencyList.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            {/* Amount */}
            <Box sx={fieldWrap}>
              <Typography sx={fieldLabel}>
                {isBuy ? "Buy Amount" : "Sell Amount"}
              </Typography>
              <TextField
                type="number"
                value={isBuy ? onlyBuyAmount : onlySellAmount}
                onChange={(e) =>
                  isBuy
                    ? getBuyVal(e.target.value)
                    : getSellVal(e.target.value)
                }
                disabled={isAmountDisabled}
                InputProps={{
                  endAdornment: selectedCounterCurrency ? (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>
                        {selectedCounterCurrency}
                      </Typography>
                    </InputAdornment>
                  ) : null,
                }}
                sx={modernFieldStyle}
                fullWidth
              />
            </Box>

            {/* Get Quote button aligned with fields */}
            <Box sx={submitWrap}>
              <ContainedButton
                variant="contained"
                disabled={isGetQuoteDisabled}
                onClick={() =>
                  isBuy ? handleGetQuoteForBuy() : handleGetQuoteForSell()
                }
                sx={{
                  ...modernSubmitStyle,
                  backgroundColor: isBuy ? "#16a34a" : "#ef4444",
                  "&:hover": {
                    backgroundColor: isBuy ? "#15803d" : "#dc2626",
                  },
                  "&.Mui-disabled": {
                    color: "#fff",
                    backgroundColor: isBuy ? "#16a34a" : "#ef4444",
                    opacity: 0.4,
                  },
                }}
                fullWidth
              >
                <RequestQuoteOutlinedIcon sx={{ fontSize: 17, mr: 0.75 }} />
                Get Quote
              </ContainedButton>
            </Box>
          </Box>

          {/* Errors */}
          {errorDepthPriceExceed && (
            <Typography sx={errorText}>
              Orderbook depth reached — price not found
            </Typography>
          )}
          {errorTotalPriceExceed && (
            <Typography sx={errorText}>
              Total price must be at least 0.001
            </Typography>
          )}
        </Box>
      </Box>

      {/* ── Quote Card — Buy ── */}
      {showQuoteAreaForBuy && (
        <Box sx={quoteCard}>
          <Box sx={quoteCardHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  ...quoteIconBadge,
                  backgroundColor: alpha("#16a34a", 0.12),
                  color: "#16a34a",
                }}
              >
                <RequestQuoteOutlinedIcon sx={{ fontSize: 16 }} />
              </Box>
              <Box>
                <Typography sx={quoteCardTitle}>Live Quote — Buy</Typography>
                <Typography sx={quoteCardSub}>
                  {selectedCounterCurrency} / {selectedBaseCurrency}
                </Typography>
              </Box>
            </Box>
            {!showRefreshButtonForBuy && (
              <Box sx={countdownBadge}>
                <Typography sx={countdownText}>{countdown}s</Typography>
              </Box>
            )}
          </Box>

          <Box sx={quoteFieldsGrid}>
            <Box sx={quoteFieldWrap}>
              <Typography sx={quoteFieldLabel}>Spend (Total Cost)</Typography>
              <TextField
                value={onlyBuyTotalPrice ?? ""}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>{selectedBaseCurrency}</Typography>
                    </InputAdornment>
                  ),
                }}
                sx={quoteReadField}
                fullWidth
              />
            </Box>
            <Box sx={quoteFieldWrap}>
              <Typography sx={quoteFieldLabel}>Unit Price</Typography>
              <TextField
                value={onlyBuyPrice ?? ""}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>{selectedBaseCurrency}</Typography>
                    </InputAdornment>
                  ),
                }}
                sx={quoteReadField}
                fullWidth
              />
            </Box>
          </Box>

          <Box sx={quoteActions}>
            <ContainedButton
              variant="contained"
              onClick={handleCancelRequestForBuy}
              sx={cancelBtn}
            >
              Cancel
            </ContainedButton>
            {!showRefreshButtonForBuy ? (
              <ContainedButton
                variant="contained"
                disabled={isLoading || !onlyBuyAmount || onlyBuyAmount === "0"}
                onClick={marketBuy}
                endIcon={
                  isLoading ? (
                    <CircularProgress size={16} sx={{ color: "#fff" }} />
                  ) : (
                    <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
                  )
                }
                sx={{
                  ...placeOrderBtn,
                  backgroundColor: "#16a34a",
                  "&:hover": { backgroundColor: "#15803d" },
                  "&.Mui-disabled": {
                    backgroundColor: "#16a34a",
                    color: "#fff",
                    opacity: 0.45,
                  },
                }}
              >
                Place Order &nbsp;{countdown}s
              </ContainedButton>
            ) : (
              <ContainedButton
                variant="contained"
                onClick={() => getBuyVal(onlyBuyAmount)}
                startIcon={<RefreshOutlinedIcon sx={{ fontSize: 16 }} />}
                sx={{
                  ...placeOrderBtn,
                  backgroundColor: btncolor,
                  "&:hover": { backgroundColor: btncolor, opacity: 0.9 },
                }}
              >
                Refresh Quote
              </ContainedButton>
            )}
          </Box>
        </Box>
      )}

      {/* ── Quote Card — Sell ── */}
      {showQuoteAreaForSell && (
        <Box sx={quoteCard}>
          <Box sx={quoteCardHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  ...quoteIconBadge,
                  backgroundColor: alpha("#ef4444", 0.1),
                  color: "#ef4444",
                }}
              >
                <RequestQuoteOutlinedIcon sx={{ fontSize: 16 }} />
              </Box>
              <Box>
                <Typography sx={quoteCardTitle}>Live Quote — Sell</Typography>
                <Typography sx={quoteCardSub}>
                  {selectedCounterCurrency} / {selectedBaseCurrency}
                </Typography>
              </Box>
            </Box>
            {!showRefreshButtonForSell && (
              <Box sx={{ ...countdownBadge, borderColor: alpha("#ef4444", 0.3), backgroundColor: alpha("#ef4444", 0.08) }}>
                <Typography sx={{ ...countdownText, color: "#ef4444" }}>{countdown}s</Typography>
              </Box>
            )}
          </Box>

          <Box sx={quoteFieldsGrid}>
            <Box sx={quoteFieldWrap}>
              <Typography sx={quoteFieldLabel}>Receive (Total)</Typography>
              <TextField
                value={onlySellTotalPrice || "0"}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>{selectedBaseCurrency}</Typography>
                    </InputAdornment>
                  ),
                }}
                sx={quoteReadField}
                fullWidth
              />
            </Box>
            <Box sx={quoteFieldWrap}>
              <Typography sx={quoteFieldLabel}>Unit Price</Typography>
              <TextField
                value={onlySellPrice || "0"}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography sx={adornText}>{selectedBaseCurrency}</Typography>
                    </InputAdornment>
                  ),
                }}
                sx={quoteReadField}
                fullWidth
              />
            </Box>
          </Box>

          <Box sx={quoteActions}>
            <ContainedButton
              variant="contained"
              onClick={handleCancelRequestForSell}
              sx={cancelBtn}
            >
              Cancel
            </ContainedButton>
            {!showRefreshButtonForSell ? (
              <ContainedButton
                variant="contained"
                disabled={!onlySellAmount || onlySellAmount === "0"}
                onClick={marketSell}
                endIcon={
                  isLoading ? (
                    <CircularProgress size={16} sx={{ color: "#fff" }} />
                  ) : (
                    <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
                  )
                }
                sx={{
                  ...placeOrderBtn,
                  backgroundColor: "#ef4444",
                  "&:hover": { backgroundColor: "#dc2626" },
                  "&.Mui-disabled": {
                    backgroundColor: "#ef4444",
                    color: "#fff",
                    opacity: 0.45,
                  },
                }}
              >
                Place Order &nbsp;{countdown}s
              </ContainedButton>
            ) : (
              <ContainedButton
                variant="contained"
                onClick={() => getSellVal(onlySellAmount)}
                startIcon={<RefreshOutlinedIcon sx={{ fontSize: 16 }} />}
                sx={{
                  ...placeOrderBtn,
                  backgroundColor: btncolor,
                  "&:hover": { backgroundColor: btncolor, opacity: 0.9 },
                }}
              >
                Refresh Quote
              </ContainedButton>
            )}
          </Box>
        </Box>
      )}

      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={localStorage.getItem("theme")}
      />
      <TermsAgreementPopup
        open={showTermsPopup}
        onClose={() => {
          setShowTermsPopup(false);
          setPendingProceed(null);
        }}
        onProceed={() => {
          if (typeof pendingProceed === "function") {
            pendingProceed();
          }
          setPendingProceed(null);
        }}
        links={termsLinks}
        theme={localStorage.getItem("theme")}
        vestingCurrency={selectedCounterCurrency}
        txnType={pendingTxnType}
      />
    </Box>
  );
}

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 560,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
  mb: 2.5,
};

const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const tabsStyle = {
  minHeight: 56,
  "& .MuiTab-root": { minHeight: 56 },
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.65,
  letterSpacing: "0.01em",
  px: 2,
  gap: 0.75,
};

const tabPanel = {
  p: { xs: 2, md: 3 },
};

const balanceStrip = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
  px: 2,
  py: 1.25,
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.12)",
};

const balanceLabel = {
  fontSize: "0.72rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.5,
};

const balanceValue = {
  fontSize: "0.95rem",
  fontWeight: 700,
  color: "var(--text-color)",
};

const fieldsGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr auto" },
  gap: 2,
  alignItems: "end",
};

const fieldWrap = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
  minWidth: 0,
};

const fieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.55,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const modernFieldStyle = {
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.9rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiInputLabel-root": { display: "none" },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
  "& .MuiInputBase-input.Mui-disabled": {
    color: "var(--text-color)",
    WebkitTextFillColor: "var(--text-color)",
    opacity: 0.45,
  },
};

const adornText = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.5,
  userSelect: "none",
};

const submitWrap = {
  display: "flex",
  alignItems: "end",
  minWidth: { md: 160 },
};

const modernSubmitStyle = {
  height: "48px",
  px: 3,
  borderRadius: "10px",
  fontWeight: 700,
  fontSize: "0.88rem",
  textTransform: "none",
  letterSpacing: "0.01em",
  color: "#fff",
};

const errorText = {
  fontSize: "0.78rem",
  color: "#ef4444",
  mt: 1.5,
  fontWeight: 500,
};

// ── Quote Card ────────────────────────────────────────────────────────────────

const quoteCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
  mb: 2.5,
  p: { xs: 2, md: 3 },
};

const quoteCardHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
  pb: 2,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};

const quoteIconBadge = {
  width: 34,
  height: 34,
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const quoteCardTitle = {
  fontSize: "0.95rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const quoteCardSub = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  opacity: 0.5,
  mt: 0.15,
  letterSpacing: "0.04em",
  fontWeight: 600,
};

const countdownBadge = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  px: 1.5,
  py: 0.5,
  borderRadius: "20px",
  border: "1.5px solid rgba(22,163,74,0.3)",
  backgroundColor: "rgba(22,163,74,0.08)",
  minWidth: 44,
};

const countdownText = {
  fontSize: "0.88rem",
  fontWeight: 800,
  color: "#16a34a",
  letterSpacing: "-0.01em",
};

const quoteFieldsGrid = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: 2,
  mb: 3,
};

const quoteFieldWrap = {
  display: "flex",
  flexDirection: "column",
  gap: 0.75,
};

const quoteFieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.5,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const quoteReadField = {
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "0.95rem",
    fontWeight: 600,
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.2)",
  },
  "& legend": { display: "none" },
  "& fieldset": { top: 0 },
};

const quoteActions = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  justifyContent: "flex-end",
};

const cancelBtn = {
  height: 44,
  px: 3,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.88rem",
  backgroundColor: "rgba(125,125,125,0.14)",
  color: "var(--text-color)",
  "&:hover": { backgroundColor: "rgba(125,125,125,0.22)" },
  boxShadow: "none",
};

const placeOrderBtn = {
  height: 44,
  px: 3,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "0.88rem",
  color: "#fff",
  letterSpacing: "0.01em",
};
